import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { updateSupplierApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const updateSupplier = createAsyncThunk('updateSupplier', async (payload) => {
  return await updateSupplierApi(payload);
});

const updateSupplierSlice = createSlice({
  name: 'updateSupplier', // Unique Name
  initialState,
  reducers: {
    updateSupplierReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateSupplier.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(updateSupplier.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(updateSupplier.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { updateSupplierReset } = updateSupplierSlice.actions;

export default updateSupplierSlice.reducer;
